import { render, staticRenderFns } from "./index.vue?vue&type=template&id=beb15fea&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=beb15fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb15fea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/data/.jenkins/workspace/yyWebsite/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beb15fea')) {
      api.createRecord('beb15fea', component.options)
    } else {
      api.reload('beb15fea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=beb15fea&scoped=true&", function () {
      api.rerender('beb15fea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/drugInfo/index.vue"
export default component.exports